// Extracted from reducer.tsx to break circular imports between reducer.tsx and slices/.

export enum PageContentType {
  LOADING_ACCOUNT = "LOADING_ACCOUNT",
  NO_WORKSPACE = "NO_WORKSPACE",
  NOT_LOGGED_IN = "NOT_LOGGED_IN",
  PULL_CONNECTOR = "PULL_CONNECTOR",
  PULL_CONNECTOR_TABLE = "PULL_CONNECTOR_TABLE",
  SELECT_CONNECT_CARD_TYPE = "SELECT_CONNECT_CARD_TYPE",
  ADD_CONNECT_CARD = "ADD_CONNECT_CARD",
  NOTEBOOK_PAGE = "NOTEBOOK",
  VIEW_PUSH_CONNECTOR = "VIEW_PUSH_CONNECTOR",
  EDIT_PUSH_CONNECTOR = "EDIT_PUSH_CONNECTOR",
  SETTINGS = "SETTINGS",
}

export interface SelectedPage {
  contentType: PageContentType;
  page?: any;
}

export enum ActionType {
  SET_PAGE_BLOCKS = "SET_PAGE_BLOCKS",
  SET_MULTIPLE_PAGE_BLOCKS = "SET_MULTIPLE_PAGE_BLOCKS",
  SET_FOLDER_PRIMARY_KEY = "SET_FOLDER_PRIMARY_KEY",
  SET_FOLDER_SEC_INDEXES = "SET_FOLDER_SEC_INDEXES",
  ADD_REGISTRATIONS = "ADD_REGISTRATIONS",
  ADD_CODE_BLOCKS = "ADD_CODE_BLOCKS",
  ADD_SETTINGS = "ADD_SETTINGS",
  SET_PAGE_PROPERTY_VALUES = "SET_PAGE_PROPERTY_VALUES",
  DELETE_PROPERTY = "DELETE_PROPERTY",
  SET_PROPERTY_TYPE_EDITS = "SET_PROPERTY_TYPE_EDITS",
  SET_SELECTED_PROPERTY = "SET_SELECTED_PROPERTY",
  SET_FOLDER_PROPERTIES = "SET_FOLDER_PROPERTIES",
  SET_PAGE_NAME = "SET_PAGE_NAME",
  SET_DELETE_TABLES = "SET_DELETE_TABLES",
  MOVE_NOTE_BLOCK = "MOVE_NOTE_BLOCK",
  FLUSH_NOTE_EDITS = "FLUSH_NOTE_EDITS",
  SET_BLOCK_INDENT_LEVEL = "SET_BLOCK_INDENT_LEVEL",
  SET_NOTE_EDIT = "SET_NOTE_EDIT",
  DELETE_BLOCK = "DELETE_BLOCK",
  FOCUS_PREVIOUS_BLOCK = "FOCUS_PREVIOUS_BLOCK",
  FOCUS_NEXT_BLOCK = "FOCUS_NEXT_BLOCK",
  SET_BLOCK_TO_FOCUS = "SET_BLOCK_TO_FOCUS",
  INSERT_BLOCK = "INSERT_BLOCK",
  SET_TABLE_LOADING = "SET_TABLE_LOADING",
  ADD_NOTEBOOK_PAGES = "ADD_NOTEBOOK_PAGES",
  REMOVE_NOTEBOOK_PAGES = "REMOVE_NOTEBOOK_PAGES",
  SET_TABLE_RUN_CONTROL = "SET_TABLE_RUN_CONTROL",
  SET_TABLE_RUN_HISTORY_MAP = "SET_TABLE_RUN_HISTORY_MAP",
  ADD_NOT_FOUND_TABLES = "ADD_NOT_FOUND_TABLES",
  SET_SELECTED_PULL_CONNECTOR = "SET_SELECTED_PULL_CONNECTOR",
  SET_CONNECTOR_STATUS_MAP = "SET_CONNECTOR_STATUS_MAP",
  SET_NOTE_EDITS = "SET_NOTE_EDITS",
  SET_TABLE_LOGS_MAP = "SET_TABLE_LOGS_MAP",
  SET_TABLE_RUN_RESPONSES = "SET_TABLE_RUN_RESPONSES",
  SET_APP_OWNER = "SET_APP_OWNER",
  SET_STRIPE_SUBSCRIPTION = "SET_STRIPE_SUBSCRIPTION",
  SET_STRIPE_CUSTOMER = "SET_STRIPE_CUSTOMER",
  SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS",
  SET_ALL_WORKSPACES = "SET_ALL_WORKSPACES",
  SET_ROLES = "SET_ROLES",
  SET_WORKSPACE_USERS = "SET_WORKSPACE_USERS",
  SET_ALL_USERS = "SET_ALL_USERS",
  SET_NOTEBOOK = "SET_NOTEBOOK",
  SET_APP_ID = "SET_APP_ID",
  SET_APPS = "SET_APPS",
  SET_HOME_APP = "SET_HOME_APP",
  SET_SELECTED_PAGE = "SET_SELECTED_PAGE",
  SET_CHAT_ID = "SET_CHAT_ID",
  SET_SIDE_NAV_OPEN = "SET_SIDE_NAV_OPEN",
  SET_CHAT_DRAWER_OPEN = "SET_CHAT_DRAWER_OPEN",
  ADD_MESSAGE = "ADD_MESSAGE",
  SET_MESSAGES = "SET_MESSAGES",
  SET_CONNECTORS = "SET_CONNECTORS",
  ADD_TABLES = "ADD_TABLES",
  ASSOCIATE_CONNECTOR_TABLES = "ASSOCIATE_CONNECTOR_TABLES",
  SET_CHAT_LOADING = "SET_CHAT_LOADING",
  SET_CONNECTOR_TYPES = "SET_CONNECTOR_TYPES",
  SET_SELECTED_CONNECTOR_TYPE = "SET_SELECTED_CONNECTOR_TYPE",
  SET_CREATE_CONNECTOR_LOADING = "SET_CREATE_CONNECTOR_LOADING",
  SET_SELECTED_CONNECT_CARD = "SET_SELECTED_CONNECT_CARD",
  SET_AUTH_TOKEN = "SET_AUTH_TOKEN",
  SET_PUSH_CONNECTORS = "SET_PUSH_CONNECTORS",
  SET_SELECTED_PUSH_CONNECTOR = "SET_SELECTED_PUSH_CONNECTOR",
  SET_PUSH_CONNECTOR_FORM_DATA = "SET_PUSH_CONNECTOR_FORM_DATA",
  SET_INITIAL_PAGE_LOADING = "SET_INITIAL_PAGE_LOADING",
  SET_NO_WORKSPACES = "SET_NO_WORKSPACES",
  ADD_TABLE_PAGE = "ADD_TABLE_PAGE",
  SET_TABLE_SPECS = "SET_TABLE_SPECS",
  SET_SELECTED_NOTEBOOK_PAGE_ID = "SET_SELECTED_NOTEBOOK_PAGE_ID",
  SET_PAGE_PAGE_VIEWS = "SET_PAGE_PAGE_VIEWS",
  SET_SELECTED_VIEW_ID = "SET_SELECTED_VIEW_ID",
  SET_VIEW_SETTING = "SET_VIEW_SETTING",
  SWAP_DATABASE_VIEWS = "SWAP_DATABASE_VIEWS",
  ADD_CHARTS = "ADD_CHARTS",
  ADD_FULL_TABLES = "ADD_FULL_TABLES",
  ADD_PULL_CONNECTOR_STATUS = "ADD_PULL_CONNECTOR_STATUS",
  ADD_PULL_CONNECTOR_URL_CONFIGS = "ADD_PULL_CONNECTOR_URL_CONFIGS",
  SET_SHIFT_DOWN = "SET_SHIFT_DOWN",
  SET_PAGE_PUBLISHED = "SET_PAGE_PUBLISHED",
  SET_SELECTED_PULL_CONNECTOR_TABLE = "SET_SELECTED_PULL_CONNECTOR_TABLE",
  ADD_COMPONENTS = "ADD_COMPONENTS",
  ADD_SERVICE_ACCOUNTS = "ADD_SERVICE_ACCOUNTS",
  ADD_DEVCONTAINERS = "ADD_DEVCONTAINERS",
  ADD_VOLUMES = "ADD_VOLUMES",
  ADD_PROTOCOLS = "ADD_PROTOCOLS",
  ADD_IMPLEMENTATIONS = "ADD_IMPLEMENTATIONS",
  SET_PAGE_COMPONENTS = "SET_PAGE_COMPONENTS",
  ADD_PAGE_IMPLEMENTATIONS = "ADD_PAGE_IMPLEMENTATIONS",
  ADD_SUB_PAGES = "ADD_SUB_PAGES",
  ADD_LOG_STREAMS = "ADD_LOG_STREAMS",
  SET_AI_PANEL_OPEN = "SET_AI_PANEL_OPEN",
  SET_AI_PANEL_FULLSCREEN = "SET_AI_PANEL_FULLSCREEN",
  ADD_AI_EVENT = "ADD_AI_EVENT",
  SET_AI_EVENTS = "SET_AI_EVENTS",
  CLEAR_AI_EVENTS = "CLEAR_AI_EVENTS",
  SET_AI_CONNECTION_STATUS = "SET_AI_CONNECTION_STATUS",
  SET_AI_CHAT_LOADING = "SET_AI_CHAT_LOADING",
  SET_LOAD_ERROR = "SET_LOAD_ERROR",
  CLEAR_LOAD_ERROR = "CLEAR_LOAD_ERROR",
  ADD_PACKAGES = "ADD_PACKAGES",
  SET_INSTALLED_PACKAGES = "SET_INSTALLED_PACKAGES",
  SET_PAGE_PROPS = "SET_PAGE_PROPS",
  ADD_SUBSCRIPTIONS = "ADD_SUBSCRIPTIONS",
  CLEAR_SUBSCRIPTION_MAP = "CLEAR_SUBSCRIPTION_MAP",
  INCREMENT_SUBSCRIPTION_REFRESH = "INCREMENT_SUBSCRIPTION_REFRESH",
  ADD_HTTP_HOOKS = "ADD_HTTP_HOOKS",
  RESET_NOTEBOOK_WORKSPACE = "RESET_NOTEBOOK_WORKSPACE",
  SET_SESSION_HISTORY = "SET_SESSION_HISTORY",
  SET_ACTIVE_SESSION_ID = "SET_ACTIVE_SESSION_ID",
  UPSERT_AI_EVENT = "UPSERT_AI_EVENT",
  ENQUEUE_AI_MESSAGE = "ENQUEUE_AI_MESSAGE",
  DEQUEUE_AI_MESSAGE = "DEQUEUE_AI_MESSAGE",
  CANCEL_AI_QUEUED = "CANCEL_AI_QUEUED",
  SET_AI_EVENTS_BATCH = "SET_AI_EVENTS_BATCH",
  PREPEND_AI_EVENTS = "PREPEND_AI_EVENTS",
  SET_AI_HISTORY_LOADING = "SET_AI_HISTORY_LOADING",
  SET_AI_HISTORY_ERROR = "SET_AI_HISTORY_ERROR",
  SET_SELECTED_MODEL = "SET_SELECTED_MODEL",
  SET_SELECTED_PROVIDER = "SET_SELECTED_PROVIDER",
  SET_AI_IDENTITY = "SET_AI_IDENTITY",
  SET_SELECTED_DEVCONTAINER = "SET_SELECTED_DEVCONTAINER",
}

export interface Action {
  type: ActionType;
}
